import styled from 'styled-components';
import { ReactComponent as MoveIcon_ } from 'Images/moveAsset.svg';

export const MoveIcon = styled(MoveIcon_)`
 circle {
    fill: ${({ theme }) => theme.backgrounds.modal};
    stroke: ${({ theme }) => theme.icons.actionBar.color};
  }
  g > g > path:last-of-type {
    stroke: ${({ theme }) => theme.icons.actionBar.color};
  }
  &:hover {
    circle, g > g > path:last-of-type {
      stroke: ${({ theme }) => theme.icons.actionBar.hover};
    }
  }
`;

MoveIcon.displayName = 'MoveIcon';

export default MoveIcon;
